import React from "react"
import { Link } from "gatsby"
import styled, { withTheme } from "styled-components"
import { PropTypes } from "prop-types"
import { CSSTransition } from "react-transition-group"
import PodcastIcon from "../../assets/podcast.inline.svg"


const Holder = styled.nav`
  overflow: hidden;
  position: relative;

  &.nav-appear,
  &.nav-enter {
    height: 0;
    ul {
      transform: translateY(-100%);
    }
  }
  &.nav-appear-active,
  &.nav-appear-done,
  &.nav-enter-active,
  &.nav-enter-done {
    height: 3rem;
    transition: height 250ms;
    @media (${(props) => props.theme.breakpoints.lg}) {
      height: 2rem;
    }
    ul {
      transform: translateY(0);
      transition: transform 250ms;
    }
  }
  &.nav-exit {
    height: 3rem;
    @media (${(props) => props.theme.breakpoints.lg}) {
      height: 2rem;
    }
    ul {
      transform: translateY(0);
    }
  }
  &.nav-exit-active {
    height: 0;
    transition: height 250ms;
    ul {
      transform: translateY(-100%);
      transition: transform 250ms;
    }
  }

  ul {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    list-style: none;
    padding-left: 0;
    margin: 0;

    a {
      text-decoration: none;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      width: 100%;
      padding-left: 0.5rem;


      @media (${(props) => props.theme.breakpoints.sm}) {
        justify-content: space-between;
        padding-left: 1rem;
        align-items: center;

      }
    }

    .active {
      background-color: var(--orange);
      color: black;

      .dot {
      display: none;

      @media (${(props) => props.theme.breakpoints.sm}) {
      display: block;
      
      margin-right: 1rem;


      @keyframes bounce1 {
        0% { stroke-opacity: 0; }
        100% { stroke-opacity: 1; }
      }

      @keyframes bounce2 {
        25% { stroke-opacity: 0; }
        100% { stroke-opacity: 1; }
      }

      @keyframes bounce3 {
        50% { stroke-opacity: 0; }
        100% { stroke-opacity: 1; }
      }

  #circle-1 {
    animation: bounce1 1.5s linear infinite;
    
}
    
 #circle-2 {
      animation: bounce2 1.5s linear infinite;
 }

 #circle-3 {
  animation: bounce3 1.5s linear infinite ;
}
      }
      
    }
    }
  

  }
`

const Item = styled.li`
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  /* line-height: 5rem; */
  text-align: center;
  font-size: 13px;
  background-color: black;
  color: white;

  
  @media (${(props) => props.theme.breakpoints.sm}) {
    font-size: ${(props) => props.theme.fluidType(-2)};
  }
  text-transform: uppercase;
  font-weight: 700;
  @media (${(props) => props.theme.breakpoints.lg}) {
    line-height: 2rem;
  }
  
`

function Navigation({ theme, showNav }) {


  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      appear
      in={showNav}
      timeout={250}
      classNames="nav"
    >
      <Holder>
        <ul>
            <Item bg={theme.colours.orange}>
              <Link 
              to="/work/"
              activeClassName="active"
              >
                <span>Work</span>
                <PodcastIcon className="dot" />
              </Link>
            </Item>
            
            <Item bg={theme.colours.orange}>
              <Link 
              to="/services/"
              activeClassName="active">
                <span>Services</span>
                <PodcastIcon className="dot" />
              </Link>
            </Item>

            <Item bg={theme.colours.orange}>
              <Link 
              to="/about/"
              activeClassName="active"
              >
                <span>About</span>
                <PodcastIcon className="dot" />
              </Link>
            </Item>

            <Item bg={theme.colours.orange}>
              <Link 
              to="/journal/"
              activeClassName="active">
                <span>Journal</span>
                <PodcastIcon className="dot" />
                {/* <div className={"dot"}></div> */}
              </Link>
            </Item>
          
        </ul>
      </Holder>
    </CSSTransition>
  )
}

Navigation.propTypes = {
  theme: PropTypes.object,
  showNav: PropTypes.bool.isRequired,
}

export default withTheme(Navigation)
